(function (module) {
    'use strict';
    module.directive('focusInputInvalid', function () {
        return {
            link: function (scope, element, attr) {
                element.on('submit', function () {
                    var firstElement = element[0].querySelector('.ng-invalid');
                    if (firstElement) {
                        firstElement.focus();
                    }
                });
            }
        };
    });
}(angular.module('emarket.commons')));